import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import { common_container } from '../main/dealList/components/deals/TopCard';
import LinkButton from './LinkButton';

const CessationCard: React.FC = () => {
    const navigate = useNavigate();

    const redirectToCessationPlan = () => {
        return navigate(HEADERMENU_PATH.cessationPlan);
    };

    return (
        <div className={`overflow-hidden bg-[#13223E] h-full relative m-auto ${common_container}`}>
            <div className="flex gap-1 justify-between w-full py-4 md:items-center md:flex-row flex-col">
                {' '}
                <p className="text-[#FFFFFF] font-[WorkSans-Semibold]">
                    Helicap Securities Pte. Ltd.'s cessation plan, as per MAS guidelines
                </p>
                <LinkButton title="View Here" onClick={redirectToCessationPlan} isArrow variant="light" size="sm" />
            </div>
        </div>
    );
};

export default CessationCard;
